import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";

export function getSDLaneRestrictionStyleNormal(feature) {
  return getSDLaneRestrictionColorStyle(feature);
}

export function getSDLaneRestrictionHovStyleNormal(feature) {
  return getSDLaneRestrictionHovColorStyle(feature);
}

export function getSDLaneRestrictionStyleClick(feature) {
  return getSDLaneRestrictionHovColorStyle(feature, true, false);
}

export function getSDLaneRestrictionStyleHover(feature) {
  return getSDLaneRestrictionHovColorStyle(feature, false, true);
}

function getSDLaneRestrictionHovColorStyle(
  feature,
  click = false,
  hover = false,
) {
  let color;
  let lineDash = null;
  let width;
  const tags = extractTags(feature);
  if (tags.rm_hovLanes) {
    color = "orange";
    width = 8;
  } else {
    color = "black";
    width = 2;
  }
  if (click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: 6,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "orange",
          width: 4,
          lineDash: lineDash,
        }),
      }),
    ];
  }
  if (hover) {
    return [
      new Style({
        stroke: new Stroke({
          color: "white",
          width: 8,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: 4,
          lineDash: lineDash,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
        lineDash: lineDash,
      }),
    }),
  ];
}

function isOnlyBusAllowed(tags) {
  if (
    tags.rm_vehicleAccessHgv &&
    tags.rm_vehicleAccessHgv.includes("no") &&
    tags.rm_vehicleAccessMotorcar &&
    tags.rm_vehicleAccessMotorcar.includes("no") &&
    tags.rm_vehicleAccessTaxi &&
    tags.rm_vehicleAccessTaxi.includes("no") &&
    !tags.rm_vehicleAccessBus
  ) {
    return true;
  }
  return false;
}

function isOnlyTaxiAndBusAllowed(tags) {
  if (
    tags.rm_vehicleAccessHgv &&
    tags.rm_vehicleAccessHgv.includes("no") &&
    tags.rm_vehicleAccessMotorcar &&
    tags.rm_vehicleAccessMotorcar.includes("no") &&
    !tags.rm_vehicleAccessBus &&
    !tags.rm_vehicleAccessTaxi
  ) {
    return true;
  }
  return false;
}

function isOnlyTaxiAllowed(tags) {
  if (
    tags.rm_vehicleAccessHgv &&
    tags.rm_vehicleAccessHgv.includes("no") &&
    tags.rm_vehicleAccessMotorcar &&
    tags.rm_vehicleAccessMotorcar.includes("no") &&
    tags.rm_vehicleAccessBus &&
    tags.rm_vehicleAccessBus.includes("no") &&
    !tags.rm_vehicleAccessTaxi
  ) {
    return true;
  }
  return false;
}

function isHgvNotAllowed(tags) {
  if (
    tags.rm_vehicleAccessHgv &&
    tags.rm_vehicleAccessHgv.includes("no") &&
    !tags.rm_vehicleAccessTaxi &&
    !tags.rm_vehicleAccessMotorcar &&
    !tags.rm_vehicleAccessBus
  ) {
    return true;
  }
  return false;
}

function isFullyClosed(tags) {
  if (
    tags.rm_vehicleAccessHgv &&
    tags.rm_vehicleAccessHgv.includes("no") &&
    tags.rm_vehicleAccessTaxi &&
    tags.rm_vehicleAccessTaxi.includes("no") &&
    tags.rm_vehicleAccessBus &&
    tags.rm_vehicleAccessBus.includes("no") &&
    tags.rm_vehicleAccessMotorcar &&
    tags.rm_vehicleAccessMotorcar.includes("no")
  ) {
    return true;
  }
  return false;
}

function getSDLaneRestrictionColorStyle(feature, click = false, hover = false) {
  let color;
  let lineDash = null;
  let width;
  const tags = extractTags(feature);
  // bus ==> maroon, hgv ==> purple, psv ==> blue, taxi ==> yellow, hov ==> orange, motor_vehicle restriction ==> darkgrey, else grey

  if (isOnlyBusAllowed(tags)) {
    color = "maroon";
    width = 8;
  } else if (isOnlyTaxiAndBusAllowed(tags)) {
    color = "blue";
    width = 8;
  } else if (isOnlyTaxiAllowed(tags)) {
    color = "yellow";
    width = 8;
  } else if (isHgvNotAllowed(tags)) {
    color = "purple";
    width = 8;
  } else if (isFullyClosed(tags)) {
    color = "darkgrey";
    width = 8;
  } else {
    color = "black";
    width = 2;
  }
  if (click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: 6,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "orange",
          width: 4,
          lineDash: lineDash,
        }),
      }),
    ];
  }
  if (hover) {
    return [
      new Style({
        stroke: new Stroke({
          color: "white",
          width: 8,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: 4,
          lineDash: lineDash,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
        lineDash: lineDash,
      }),
    }),
  ];
}
